<template>
  <div class="border-b-slate-300 border-b px-12 h-20 flex items-center text-2xl font-bold mb-10"><slot></slot></div>
</template>

<script setup lang="ts"></script>
